import type { AIconProps } from '../../atoms/AIcon/AIcon.types';
import type { ASubheaderProps } from '../../atoms/ASubheader/ASubheader.types';
import type { ABodyProps } from '../../atoms/ABody/ABody.types';
import type { ADigitProps } from '../../atoms/ADigit/ADigit.types';
import type { AAccentLineProps } from '../../atoms/AAccentLine/AAccentLine.types';
import type { MHighlightIconAlignment } from '../../molecules/MHighlightIcon/MHighlightIcon.types';
import type { MHighlightNumericAlignment } from '../../molecules/MHighlightNumeric/MHighlightNumeric.types';
import type { MHighlightTextAlignment } from '../../molecules/MHighlightText/MHighlightText.types';

export enum OCardHighlightType {
  Icon = 'Icon',
  Numeric = 'Numeric',
  Text = 'Text',
}

export interface OCardHighlightIconItem {
  alignment?: MHighlightIconAlignment;
  showCTA?: boolean;
  aIcon: AIconProps;
  aSubheader: ASubheaderProps;
  aBody?: ABodyProps;
  mButton?: OCardHighlightButton;
}

export interface OCardHighlightNumericItem {
  alignment?: MHighlightNumericAlignment;
  showCTA?: boolean;
  aDigit: ADigitProps;
  aAccentLine?: AAccentLineProps;
  aBody?: ABodyProps;
  mButton?: OCardHighlightButton;
}

export interface OCardHighlightTextItem {
  alignment?: MHighlightTextAlignment;
  showCTA?: boolean;
  aSubheader: ASubheaderProps;
  aAccentLine?: AAccentLineProps;
  aBody?: ABodyProps;
  mButton?: OCardHighlightButton;
}

export interface OCardHighlightButton {
  buttonText?: string;
  type?: string;
  ctaLink?: string;
  openInANewTab?: string | boolean;
  size?: string;
  icon?: string;
}

export interface OCardHighlightTrackingProperties {
  location?: string;
  trackingTag?: string;
  trackingContentPosition?: string;
  trackingDescription?: string;
  trackingOfferType?: string;
  merchandisingCategory?: string;
  atCCeVar48?: string;
  clickTrack?: boolean;
  impressionTrack?: boolean;
  impressionCount?: boolean;
  enableScrollingBehavior?: boolean;
  leftArrowDesc?: string;
  cardLocation?: string;
  rightArrowDesc?: string;
  description?: string;
  faicMCD?: string;
  additionalTrackingVariables?: string;
}

export interface OCardHighlightProps {
  highlightType: OCardHighlightType;
  mHighlightIcon?: OCardHighlightIconItem;
  mHighlightNumeric?: OCardHighlightNumericItem;
  mHighlightText?: OCardHighlightTextItem;
  trackingProperties?: OCardHighlightTrackingProperties;
  className?: string;
}
